import React, { useState } from "react";
import GetInfoForm from "./getInfoForm";
import { Container } from "./layout";
import { Button } from "./form";
import Image from "../images/footer-image.jpg";

export default function Cta() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="overflow-hidden relative">
      <div
        className="px-4 py-16 sm:py-24 lg:py-32 xl:py-40 bg-no-repeat bg-cover bg-center"
        style={{
          backgroundImage: `url(${Image})`,
        }}
      >
        <div className="text-center text-white m-auto">
          <h3 className="text-2xl font-bold uppercase mb-6">
            This is Where You Belong
          </h3>
          <p className="text-base mb-6">
            The future you've been waiting for starts at Maryville.
          </p>
          <Button
            onClick={() => {
              setShowForm(true);
            }}
            extraClasses={`hover:bg-red focus:bg-red${
              showForm ? " opacity-0" : ""
            }`}
          >
            Get Info
          </Button>
        </div>
      </div>
      <Container
        extraClasses={`-mt-28 px-8 bg-white py-12 transition-transform duration-500 transform ${
          showForm ? "translate-y-0" : "translate-y-full absolute"
        }`}
      >
        <button
          onClick={() => {
            setShowForm(false);
          }}
          className="absolute w-6 h-6 top-4 right-4"
        >
          <span
            className={`absolute block w-6 h-0.5 bg-red top-bar transform rotate-45
              `}
          ></span>
          <span
            className={`absolute block w-6 h-0.5 bg-red bottom-bar transform -rotate-45`}
          ></span>
        </button>
        <GetInfoForm />
      </Container>
    </div>
  );
}
